function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#393762",
  strokeLinejoin: "round",
  strokeWidth: 1.6,
  opacity: 0.4
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 15s-1.5-.5-1.5-3c-.826 0-.826-2 0-2 0-.335-1.5-4 1-3.5.5-2 6-2 6.5 0 .347 1.388-.5 3.254-.5 3.5.826 0 .826 2 0 2 0 2.5-1.5 3-1.5 3v2.5c2.477.929 4.93 1.697 6.186 2.575C22.234 17.999 23.5 15.147 23.5 12 23.5 5.648 18.352.5 12 .5S.5 5.648.5 12c0 3.153 1.27 6.009 3.325 8.087 1.33-.92 3.952-1.746 6.175-2.587V15h0z",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.825 20.087C5.91 22.194 8.802 23.5 12 23.5c3.203 0 6.1-1.31 8.185-3.425",
  transform: "translate(1 1)"
}));

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.f2ac08c8.svg";
export { ForwardRef as ReactComponent };